module.exports = __webpack_public_path__ + "img/V88.f619ecd5.jpg";